"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRadioOptionColors = exports.getStatusLabelColor = exports.getBorderColor = void 0;
var constants_1 = require("../../constants");
var getBorderColor = function (isReadOnly, isSelected, status, theme) {
    var CORRECT = constants_1.OPTION_LABEL.CORRECT, INCORRECT = constants_1.OPTION_LABEL.INCORRECT, CORRECT_NOT_SELECTED = constants_1.OPTION_LABEL.CORRECT_NOT_SELECTED;
    var Colors = theme.Colors;
    var success100 = Colors.success100, error100 = Colors.error100;
    if (!isReadOnly) {
        return isSelected ? '#22286E' : '#2e3692';
    }
    switch (status) {
        case CORRECT:
            return success100;
        case INCORRECT:
            return error100;
        case CORRECT_NOT_SELECTED:
            return success100;
        default:
            return '#AFB6CA';
    }
};
exports.getBorderColor = getBorderColor;
var getStatusLabelColor = function (status, theme) {
    var CORRECT = constants_1.OPTION_LABEL.CORRECT, INCORRECT = constants_1.OPTION_LABEL.INCORRECT, CORRECT_NOT_SELECTED = constants_1.OPTION_LABEL.CORRECT_NOT_SELECTED;
    var Colors = theme.Colors;
    var success120 = Colors.success120, error100 = Colors.error100;
    switch (status) {
        case CORRECT:
            return success120;
        case INCORRECT:
            return error100;
        case CORRECT_NOT_SELECTED:
            return success120;
        default:
            return '';
    }
};
exports.getStatusLabelColor = getStatusLabelColor;
var getRadioOptionColors = function (isReadOnly, status, theme) {
    var CORRECT = constants_1.OPTION_LABEL.CORRECT, INCORRECT = constants_1.OPTION_LABEL.INCORRECT;
    var Colors = theme.Colors;
    var success10 = Colors.success10, error10 = Colors.error10, white = Colors.white;
    if (isReadOnly) {
        switch (status) {
            case CORRECT:
                return success10;
            case INCORRECT:
                return error10;
            default:
                return white;
        }
    }
    return white;
};
exports.getRadioOptionColors = getRadioOptionColors;
